export default __webpack_public_path__ + "static/media/img-new-playbook-for-restaurants.a1d15a62.png";